<template>
    <div style="margin: 30px">
        <el-row :gutter="20">
            <el-col :offset="4" :span="6">
                <div class="grid-content bg-purple">
                    Last Update Notifications
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    {{ lastUpdateNotifications }}
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-top: 10px"  :gutter="20">
            <el-col :offset="4" :span="6">
                <div class="grid-content bg-purple">
                    Last Update Components
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    {{ lastUpdateComponents }}
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<style>

</style>

<script>
    import { LastUpdateNotifications, LastUpdateComponents } from '../api.js'

    export default {
        name: "Overview",
        props: {},
        data: function() {
            return {
                lastUpdateNotifications: '',
                lastUpdateComponents: ''
            }
        },
        methods: {
             getLastUpdate: async function() {
                 this.lastUpdateNotifications = await LastUpdateNotifications();
                 this.lastUpdateComponents = await LastUpdateComponents();
            }
        },
        mounted() {
            this.getLastUpdate();
        }
    }
</script>